import { FC, useMemo } from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { isEmpty } from '@npi/buddy-utils';

import { DocumentUploadedPreview, File } from 'src/components/DocumentUploadedPreview';

interface SupportingDocumentsView {
    heading: string;
    documents: {
        label?: string;
        file: File;
    }[];
}

export const SupportingDocumentsView: FC<SupportingDocumentsView> = ({ documents, heading }) => {
    const data = useMemo(() => {
        return documents.filter((el) => {
            return !isEmpty(el.file) && el?.file?.url;
        });
    }, [documents]);

    return (
        <Box>
            <Typography
                fontSize="20px"
                lineHeight="28px"
                fontWeight="500"
                color="#1d1d1b"
                marginBottom="24px"
            >
                {heading}
            </Typography>
            <Grid container rowSpacing={1} columns={2} gap="8px">
                {data.length ? (
                    data.map((document) => {
                        return (
                            <DocumentUploadedPreview
                                file={document.file}
                                key={document.label}
                                label={document.label}
                                boxProps={{ width: '49%' }}
                            />
                        );
                    })
                ) : (
                    <Typography>No Documents have been uploaded</Typography>
                )}
            </Grid>
        </Box>
    );
};
